import React, { useEffect } from 'react';
import imageCompression from 'browser-image-compression';

const ImageConverter = () => {
  const convertImageToWebP = async (img) => {
    try {
      
      const response = await fetch(img.src);
      

      
      const options = {
        maxSizeMB: 1, 
        maxWidthOrHeight: 1024, 
        useWebWorker: true, 
        fileType: 'image/webp', 
      };
      const webpFile = await imageCompression( options);

      
      const webpURL = URL.createObjectURL(webpFile);

      
      img.src = webpURL;
    } catch (error) {
      console.error('Error converting image to WebP:', error);
    }
  };

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG' && mutation.attributeName === 'src') {
          const img = mutation.target;
          convertImageToWebP(img);
        }
      });
    });

    const config = {
      attributes: true, 
      childList: true, 
      subtree: true, 
    };

    observer.observe(document.body, config); 

    
    return () => observer.disconnect();
  }, []);

  return null; 
};

export default ImageConverter;
